/**
 * The navigation icons.
 *
 * Drawn rather than typed: an emoji is a different picture on every phone — Apple's calendar is a
 * red 17, Google's is blue, Samsung's is something else again — and a row of them never looks like
 * one set. These are one stroke weight, one grid, and they take the colour of the tab they sit in.
 */
const common = {
  width: 22,
  height: 22,
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.8,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
  'aria-hidden': 'true',
}

export function ChatIcon() {
  return (
    <svg {...common}>
      <path d="M21 12a8 8 0 0 1-8 8H7l-4 3v-6.5A8 8 0 0 1 11 4h2a8 8 0 0 1 8 8Z" />
    </svg>
  )
}

export function PostsIcon() {
  return (
    <svg {...common}>
      <rect x="3" y="4" width="18" height="16" rx="3" />
      <path d="m3 16 4.5-4.5a2 2 0 0 1 2.8 0L15 16" />
      <path d="m14 14 1.6-1.6a2 2 0 0 1 2.8 0L21 15" />
      <circle cx="15.5" cy="8.5" r="1.4" />
    </svg>
  )
}

export function CalendarIcon() {
  return (
    <svg {...common}>
      <rect x="3" y="5" width="18" height="16" rx="3" />
      <path d="M3 10h18M8 3v4M16 3v4" />
      <circle cx="8.5" cy="14.5" r="1.1" fill="currentColor" stroke="none" />
      <circle cx="15.5" cy="14.5" r="1.1" fill="currentColor" stroke="none" />
    </svg>
  )
}

export function AnalyticsIcon() {
  return (
    <svg {...common}>
      <path d="M4 20V10M10 20V4M16 20v-7M22 20H2" />
    </svg>
  )
}

export function ProfileIcon() {
  return (
    <svg {...common}>
      <circle cx="12" cy="8.5" r="3.5" />
      <path d="M4.5 20a7.5 7.5 0 0 1 15 0" />
    </svg>
  )
}

/** The send arrow. Up rather than right: the message goes into the conversation above it. */
export function SendIcon() {
  return (
    <svg {...common} width={20} height={20}>
      <path d="M12 19V5" />
      <path d="m5 12 7-7 7 7" />
    </svg>
  )
}
